import React from 'react';
import Image from 'next/image';

interface HeroSectionProps {
  imageSrc: string;
}

const HeroSection: React.FC<HeroSectionProps> = ({ imageSrc }) => {
  const styles = {
    container: {
      position: 'relative' as const,
      width: '100%',
      height: 'auto',
      marginBottom: '2rem'
    },
    image: {
      width: '100%',
      height: 'auto',
      objectFit: 'cover' as const
    }
  };

  return (
    <div style={styles.container}>
      <img 
        src={imageSrc} 
        alt="KTX Hero Banner"
        style={styles.image}
      />
    </div>
  );
};

export default HeroSection;
